import { render } from "./settings-controllers-ZeroInjection.vue?vue&type=template&id=1d5715e8"
import script from "./settings-controllers-ZeroInjection.vue?vue&type=script&lang=js"
export * from "./settings-controllers-ZeroInjection.vue?vue&type=script&lang=js"

import "./settings-controllers-ZeroInjection.vue?vue&type=style&index=0&id=1d5715e8&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__